import { memo } from "react"
import { Row, Col, Container } from "react-bootstrap";
import { BzButton } from "../../../../components";

const OrderTable = ({ fundDetails }) => {
    return (<Container fluid className='p-0'>
        <Row className='g-0'>
            <Col md={5} className='mrgauto p-3'>
                <Row className='g-0 my-3'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='font-bold font-size4 color-text'>Additional Details</div>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <BzButton className='btn btn-sm btn-outline text-capitalize ms-3'>CANCEL</BzButton>
                        <BzButton className='btn btn-sm btn-primary text-capitalize ms-3'>MODIFY</BzButton>
                    </Col>
                </Row>

                <Row className='g-0'>
                    <Col>
                        <table className='table table-hover table-bordered table-striped'>
                            <tbody>
                                <tr>
                                    <td className='font-bold'>Switch From</td>
                                    <td className='text-truncate'>{fundDetails?.switchFrom}</td>
                                    <td className='font-bold'>Switch To</td>
                                    <td className='text-truncate'>{fundDetails?.switchTo}</td>
                                </tr>
                                <tr>
                                    <td className='font-bold'>Date&Time</td>
                                    <td className='text-truncate'>{fundDetails?.dateTime}</td>
                                    <td className='font-bold'>Modified from</td>
                                    <td className='text-truncate'>{fundDetails?.modifiedFrom}</td>
                                </tr>
                                <tr>
                                    <td className='font-bold'>Exchange Order No.</td>
                                    <td className='text-truncate'>{fundDetails?.exchangeOrderNo}</td>
                                    <td className='font-bold'>Per Order</td>
                                    <td className='text-truncate'>{fundDetails?.preOrder || '-'}</td>
                                </tr>
                                <tr>
                                    <td className='font-bold'>Rejection Reason</td>
                                    <td className='text-truncate'>{fundDetails?.rejectionReason || '-'}</td>
                                    <td className='font-bold'>Cancel on Logout</td>
                                    <td className='text-truncate'>{fundDetails?.cancelOnLogout || '-'}</td>
                                </tr>
                                <tr>
                                    <td className='font-bold'>Initiated From</td>
                                    <td className='text-truncate'>{fundDetails?.initiatedFrom || '-'}</td>
                                    <td className='font-bold'>Last Updated Time</td>
                                    <td className='text-truncate'>{fundDetails?.lastUpdatedTime || '-'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Col>
        </Row>
    </Container>)
}
export default memo(OrderTable)